<template>
  <v-row>
    <input-text
      v-model="filtro.codigo"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.codigo')"
      :placeholder="$t('modulos.agendamento.filtro.codigo')"
      em-filtro
    />
    <input-date
      v-model="filtro.dataInicial"
      mask="##/##/####"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.data_inicial')"
      :placeholder="$t('modulos.agendamento.filtro.data_inicial')"
      em-filtro
      pode-limpar-data
      nudge="-175px"
      transition="''"
    />
    <input-date
      v-model="filtro.dataFinal"
      mask="##/##/####"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.data_final')"
      :placeholder="$t('modulos.agendamento.filtro.data_final')"
      em-filtro
      pode-limpar-data
      nudge="-175px"
      transition="''"
    />
    <input-text
      v-model="filtro.tipoVisita"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.tipo_visita')"
      :placeholder="$t('modulos.agendamento.filtro.tipo_visita')"
      em-filtro
    />
    <input-text
      v-model="filtro.solicitante"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.solicitante')"
      :placeholder="$t('modulos.agendamento.filtro.solicitante')"
      em-filtro
    />
    <input-text
      v-model="filtro.cidade"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.cidade')"
      :placeholder="$t('modulos.agendamento.filtro.cidade')"
      em-filtro
    />
    <input-text
      v-model="filtro.contratante"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.contratante')"
      :placeholder="$t('modulos.agendamento.filtro.contratante')"
      em-filtro
    />
    <input-text
      v-model="filtro.contatoContratante"
      class="col-6"
      :label="$t('modulos.agendamento.filtro.contato_contratante')"
      :placeholder="$t('modulos.agendamento.filtro.contato_contratante')"
      em-filtro
    />
    <input-select
      v-model="filtro.situacao"
      :options="opcoes.tipoSituacao"
      :label="$t('modulos.agendamento.filtro.situacao')"
      :placeholder="$t('geral.inputs.selecione')"
      class="col-12 col-md-6"
      em-filtro
      retornar-objeto
    />
  </v-row>
</template>

<script>
import { enumAgendamentosIcons } from '@enums/iconsAgendamentos';
export default {
  props: {
    filtro: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      opcoes: {
        tipoSituacao: [],
      },
    };
  },
  mounted() {
    this.opcoes.tipoSituacao = enumAgendamentosIcons.map((situacao) => {
      return { value: situacao.value, text: situacao.message };
    });
  },
};
</script>
